import React from "react";
import { Link } from "react-router-dom";
import { Logo } from "../Logo";
import { useLang } from "../../contexts/LanguageContext";
import { useContentText } from "../../contexts/ContentContext";

export const Footer = () => {
  const { t, lang } = useLang();
  const { content, cl } = useContentText();
  const brand = content?.brand || {};

  return (
    <footer className="border-t border-white/5 mt-32 bg-[var(--monzal-bg)]" data-testid="site-footer">
      <div className="max-w-[1400px] mx-auto px-5 lg:px-10 py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <Logo size={32} />
            <p className="text-sm text-gray-400 mt-6 max-w-sm leading-relaxed">
              {cl("brand", "tagline",
                lang === "es"
                  ? "MONZAL es una casa de genética exótica con base en México. Linaje verificado, cuidado de élite y una marca de culto."
                  : "MONZAL is an exotic genetics house based in Mexico. Verified lineage, elite care, cult aesthetics."
              )}
            </p>
            <div className="mt-8 flex gap-3 flex-wrap">
              {brand.footer_tag_1 && <span className="tag-gold">{brand.footer_tag_1}</span>}
              {brand.footer_tag_2 && <span className="tag-tech">{brand.footer_tag_2}</span>}
              {brand.footer_tag_3 && <span className="tag-tech">{brand.footer_tag_3}</span>}
            </div>
          </div>
          <div className="md:col-span-2">
            <div className="overline mb-5">{t("nav.marketplace")}</div>
            <ul className="space-y-3 text-sm">
              <li><Link to="/marketplace" className="text-gray-300 hover:text-[var(--monzal-gold)]">Reptiles</Link></li>
              <li><Link to="/breeders" className="text-gray-300 hover:text-[var(--monzal-gold)]">{t("nav.breeders")}</Link></li>
              <li><Link to="/wishlist" className="text-gray-300 hover:text-[var(--monzal-gold)]">{t("nav.wishlist")}</Link></li>
            </ul>
          </div>
          <div className="md:col-span-2">
            <div className="overline mb-5">{t("nav.shop")}</div>
            <ul className="space-y-3 text-sm">
              <li><Link to="/shop?cat=enclosure" className="text-gray-300 hover:text-[var(--monzal-gold)]">{t("shop.enclosure")}</Link></li>
              <li><Link to="/shop?cat=accessories" className="text-gray-300 hover:text-[var(--monzal-gold)]">{t("shop.accessories")}</Link></li>
              <li><Link to="/shop?cat=food" className="text-gray-300 hover:text-[var(--monzal-gold)]">{t("shop.food")}</Link></li>
              <li><Link to="/shop?cat=merch" className="text-gray-300 hover:text-[var(--monzal-gold)]">{t("shop.merch")}</Link></li>
            </ul>
          </div>
          <div className="md:col-span-3">
            <div className="overline mb-5">{lang === "es" ? "Contacto" : "Contact"}</div>
            <ul className="space-y-3 text-sm">
              {brand.email && <li className="text-gray-400 font-mono-tech text-xs">{brand.email}</li>}
              {brand.phone && <li className="text-gray-400 font-mono-tech text-xs">{brand.phone}</li>}
              <li className="text-gray-400 text-xs mt-6">© {new Date().getFullYear()} MONZAL</li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
